import styled, { css, Theme } from 'styled-components'

const getHoverBorderColor = (props: { selected: boolean; theme: Theme }) => {
  return props.selected ? props.theme.colors.grey3 : props.theme.colors.grey2
}

const getHoverBackgroundColor = (props: { selected: boolean; theme: Theme }) => {
  return props.selected ? props.theme.colors.grey3 : props.theme.colors.grey8
}

const getNoClickableHoverBorderColor = (props: { selected: boolean; theme: Theme }) => {
  return props.selected ? props.theme.colors.grey2 : props.theme.colors.grey5
}

const getNoClickableHoverBackgroundColor = (props: { selected: boolean; theme: Theme }) => {
  return props.selected ? props.theme.colors.grey2 : props.theme.colors.grey8
}

export const PillWrapper = styled.div<{ selected: boolean }>`
  font-size: ${props => props.theme.fonts.sizes.s};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block: 8px;
  padding-inline: 12px;
  gap: 8px;
  color: ${props => (props.selected ? props.theme.colors.grey8 : props.theme.colors.grey3)};
  border: 2px solid
    ${props => (props.selected ? props.theme.colors.grey2 : props.theme.colors.grey5)};
  background: ${props => (props.selected ? props.theme.colors.grey2 : props.theme.colors.grey8)};
  border-radius: 50px;
  white-space: nowrap;
  cursor: pointer;

  svg {
    fill: ${props => (props.selected ? props.theme.colors.grey8 : props.theme.colors.grey3)};
  }

  ${props =>
    props.onClick
      ? css`
          &:hover {
            border-color: ${getHoverBorderColor(props)};
            background: ${getHoverBackgroundColor(props)};
          }
        `
      : css`
          border: 2px solid ${getNoClickableHoverBorderColor(props)};
          background: ${getNoClickableHoverBackgroundColor(props)};
          pointer-events: none;
          cursor: default;
        `}
`
